// extracted by mini-css-extract-plugin
export var isPrintedCell = "_xj-1";
export var printerIcon = "_xj-0";